var _defs, _rect, _path, _path2, _path3, _path4, _rect2, _path5, _rect3, _path6, _rect4, _path7, _rect5, _path8, _polyline, _polygon, _polygon2, _path9, _polyline2, _polyline3, _polygon3, _polygon4, _path10, _polyline4, _path11, _polygon5, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBot02(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u5716\\u5C64_1",
    "data-name": "\\u5716\\u5C64 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 185 208",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#6aece8;}.cls-2{fill:#fff;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 40.5,
    y: 24,
    width: 104,
    height: 59
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M158,27.51a23.5,23.5,0,0,1,0,47Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M158.5,28a23,23,0,0,1,0,46V28m-1-1V75a24,24,0,0,0,0-48Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27,74.49a23.5,23.5,0,0,1,0-47Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5,28V74a23,23,0,0,1,0-46m1-1a24,24,0,0,0,0,48V27Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 172.5,
    width: 27,
    height: 16
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M82.5,173v15h-26V173h26m1-1h-28v17h28V172Z"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 194.5,
    width: 34,
    height: 13
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M84.5,195v12h-33V195h33m1-1h-35v14h35V194Z"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 102,
    y: 172.5,
    width: 27,
    height: 16
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M128.5,173v15h-26V173h26m1-1h-28v17h28V172Z"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 194.5,
    width: 34,
    height: 13
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M133.5,195v12h-33V195h33m1-1h-35v14h35V194Z"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "24.5 112 16.5 115 26.5 130 30.5 126 24.5 112"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "13.5 120 8.5 130 20.5 137 22.5 133 13.5 120"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "6.5 134 5.5 145 18.5 144 18.5 141 6.5 134"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5,166.5a6.5,6.5,0,0,1,13-.66l8.83,5.36a16.2,16.2,0,0,0,.7-4.7A16,16,0,1,0,5.29,178.36l4.83-9.11A6.45,6.45,0,0,1,9.5,166.5Z"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    points: "5.5 148 17.5 147 17.5 151 4.5 156"
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    points: "160.5 112 168.5 115 158.5 130 154.5 126 160.5 112"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "171.5 120 176.5 130 164.5 137 162.5 133 171.5 120"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "178.5 134 179.5 145 166.5 144 166.5 141 178.5 134"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M175.5,166.5a6.5,6.5,0,0,0-13-.66l-8.83,5.36a16.2,16.2,0,0,1-.7-4.7,16,16,0,1,1,26.71,11.86l-4.83-9.11A6.45,6.45,0,0,0,175.5,166.5Z"
  })), _polyline4 || (_polyline4 = /*#__PURE__*/React.createElement("polyline", {
    points: "179.5 148 167.5 147 167.5 151 180.5 156"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5,0V105h120V0Zm29,68a15,15,0,1,1,15-15A15,15,0,0,1,61.5,68Zm62,0a15,15,0,1,1,15-15A15,15,0,0,1,123.5,68Z"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "32.46 110 49.41 165 135.59 165 152.54 110 32.46 110"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M42.77,123.38h4c2.08,0,3.49,1.17,3.49,3,0,2.12-1.61,3.1-3.54,3.1H44.89v3.65H42.77Zm2.12,4.45H46.5c1,0,1.67-.38,1.67-1.38s-.73-1.39-1.62-1.39H44.89Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M51.9,123.38H54v8.05h4.87l-.24,1.73H51.9Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M66.88,128.94H62.2v2.49h5.16l-.25,1.73h-7v-9.78h6.94v1.73H62.2v2.1h4.68Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M71.07,130.9l-.77,2.26H68.22l3.33-9.78H74.2l3.47,9.78H75.45l-.81-2.26Zm3.12-1.73c-.7-2.07-1.14-3.38-1.38-4.26h0c-.24,1-.73,2.5-1.29,4.26Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M80.52,130.29c.22,1,.93,1.42,2.06,1.42s1.61-.45,1.61-1.16-.47-1.15-2.14-1.53c-2.67-.63-3.33-1.6-3.33-2.92,0-1.7,1.28-2.86,3.6-2.86,2.59,0,3.63,1.39,3.77,2.83H84c-.1-.61-.44-1.26-1.7-1.26-.86,0-1.38.35-1.38,1s.42,1,2,1.32c2.85.67,3.47,1.73,3.47,3.11,0,1.79-1.35,3-3.94,3s-3.79-1.22-4-3Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M94.65,128.94H90v2.49h5.16l-.25,1.73h-7v-9.78h6.93v1.73H90v2.1h4.68Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M106.85,128.94h-4.67v2.49h5.16l-.25,1.73h-7v-9.78h6.94v1.73h-4.88v2.1h4.67Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M108.85,133.16v-9.78h2.63c1.22,2.2,3.48,6.16,3.93,7.22h0c-.11-1-.11-2.72-.11-4.32v-2.9h1.92v9.78h-2.49c-1-1.91-3.55-6.46-4-7.59h0c.07.86.09,2.87.09,4.62v3Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M122.84,130c0,2.25-.73,3.27-2.87,3.27a5.93,5.93,0,0,1-1.33-.12V131.5a8.37,8.37,0,0,0,1,.06c1,0,1.12-.65,1.12-1.4v-6.78h2.11Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M134.11,128.24c0,2.72-1.63,5.06-4.81,5.06s-4.68-2.23-4.68-5,1.78-5,4.82-5C132.3,123.24,134.11,125.24,134.11,128.24Zm-7.3,0c0,1.91.84,3.35,2.57,3.35,1.88,0,2.55-1.57,2.55-3.32s-.76-3.3-2.58-3.3S126.81,126.32,126.81,128.23Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M137.78,133.16v-3.45a.63.63,0,0,0-.08-.32l-3.38-6h2.4c.75,1.48,1.73,3.44,2.22,4.5.43-1,1.5-3.08,2.24-4.5h2.21l-3.42,6a.46.46,0,0,0-.08.31v3.49Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M57.29,142.15h-3v-1.73h8v1.73h-3v8H57.29Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M63.68,140.42H65.8v3.81h3.94v-3.81h2.11v9.78H69.74V146H65.8v4.24H63.68Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M80.93,146H76.26v2.48h5.16l-.25,1.74h-7v-9.78h6.94v1.73H76.26v2.1h4.67Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M86.41,140.42h4c2.08,0,3.49,1.16,3.49,3,0,2.13-1.61,3.1-3.54,3.1H88.53v3.66H86.41Zm2.12,4.44h1.61c1,0,1.67-.38,1.67-1.37s-.73-1.39-1.62-1.39H88.53Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M96.53,147.94l-.76,2.26H93.69L97,140.42h2.66l3.47,9.78h-2.23l-.8-2.26Zm3.12-1.74c-.69-2.06-1.13-3.38-1.37-4.26h0c-.25,1-.73,2.5-1.29,4.26Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M106.46,146.28v3.92H104.4v-9.78h4.3c2.13,0,3.28,1.17,3.28,2.68a2.37,2.37,0,0,1-1.42,2.32c.48.17,1.21.68,1.21,2.43v.48a8.09,8.09,0,0,0,.14,1.87h-2a6.64,6.64,0,0,1-.21-2.2v-.14c0-1.07-.27-1.58-1.84-1.58Zm0-1.68h1.78c1.16,0,1.6-.44,1.6-1.26s-.52-1.24-1.55-1.24h-1.83Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M115.92,142.15h-3v-1.73h8v1.73h-3v8h-2.12Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M125.21,150.2v-3.46a.5.5,0,0,0-.08-.31l-3.37-6h2.39c.76,1.47,1.74,3.43,2.23,4.5.42-1,1.5-3.09,2.23-4.5h2.22l-3.42,6a.44.44,0,0,0-.08.31v3.49Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBot02);
export default __webpack_public_path__ + "static/media/bot-02.12b86f9b59cc1a50ea9621d650fb6e00.svg";
export { ForwardRef as ReactComponent };